export class SharedFilters {
  tenantUuids: string[];
  organizationUuids: string[];
  resourceName: string;
  resourceType: string;
}
